import { __, sprintf } from '@wordpress/i18n';

export const t = {
	search: __('Search', 'dealer-locator'),
	searchPlaceholder: __('Search by address, city, state or ZIP code', 'dealer-locator'),
	clearSearch: __('Clear search', 'dealer-locator'),
	openFilters: __('Open filters', 'dealer-locator'),
	openInGoogleMaps: __('Open in Google Maps', 'dealer-locator'),
	viewDetails: __('View details', 'dealer-locator'),
	fflLicense: (value) => sprintf(__('FFL License: #%s', 'dealer-locator'), value),
	phone: __('Phone:', 'dealer-locator'),
	email: __('Email:', 'dealer-locator'),
	website: __('Website:', 'dealer-locator'),
	workingHours: __('Working Hours', 'dealer-locator'),
	getDirections: __('Get directions', 'dealer-locator'),
	noDealersFound: __('No Dealers Found', 'dealer-locator'),
	noDealersNear: (value) => sprintf(__("We couldn't find any dealers near “%s”.", 'dealer-locator'), value),
	yourSearch: __('your search', 'dealer-locator'),
	tryTheseSteps: __('Try these steps:', 'dealer-locator'),
	checkSpelling: __('Check the spelling or enter a city or state name.', 'dealer-locator'),
	expandRadius: __('Expand your search radius.', 'dealer-locator'),
	filters: __('Filters', 'dealer-locator'),
	closeFilters: __('Close filters', 'dealer-locator'),
	category: __('Category', 'dealer-locator'),
	chooseCategory: __('Choose category…', 'dealer-locator'),
	status: __('Status', 'dealer-locator'),
	open: __('Open', 'dealer-locator'),
	distanceRange: __('Distance range', 'dealer-locator'),
	apply: __('Apply', 'dealer-locator'),
	resetFilters: __('Reset filters', 'dealer-locator'),
	determiningLocation: __('Determining your location…', 'dealer-locator'),
	reloadList: __('Reload list', 'dealer-locator'),
	backToList: __('Back to list', 'dealer-locator'),
	loadingDealers: __('Loading dealers…', 'dealer-locator'),
	numberOfShops: __('Number of shops', 'dealer-locator'),
};

export { __, sprintf };
